import { useCallback, useMemo } from "react";
import { Task } from "@common/types/task";
import { createScheduleSuspiciousReviewDefaultView } from "@common/types/views/scheduleReviewViews";
import {
    ScheduleReviewFooterOptions,
    ScheduleReviewTransactionsTaskBody,
} from "./ScheduleReviewTransactionsTaskBody";
import { SuspiciousTransactionReviewTaskActionBar } from "./SuspiciousTransactionReviewTaskActionBar";

interface SuspiciousTransactionReviewTaskBodyProps {
    selectedTask: Task;
}

export const SuspiciousTransactionReviewTaskBody = ({
    selectedTask,
}: SuspiciousTransactionReviewTaskBodyProps) => {
    const entityId = selectedTask.entityIds?.[0] ?? null;
    const initialFilters = useMemo(
        () => selectedTask.view?.filters ?? {},
        [selectedTask.view?.filters],
    );
    const renderFooter = useCallback(
        (options?: ScheduleReviewFooterOptions) => (
            <SuspiciousTransactionReviewTaskActionBar
                entityId={entityId}
                initialFilters={initialFilters}
                scrollTo={options?.scrollTo}
            />
        ),
        [entityId, initialFilters],
    );

    return (
        <ScheduleReviewTransactionsTaskBody
            selectedTask={selectedTask}
            buildDefaultView={createScheduleSuspiciousReviewDefaultView}
            emptyText="No suspicious transactions left to review"
            renderFooter={renderFooter}
        />
    );
};
